import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { FooterComponent } from './footer.component';


@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    HttpClientModule,
    FlexLayoutModule,
  ],
  declarations: [
    FooterComponent
  ],
  exports: [FooterComponent],
  bootstrap: [FooterComponent]
})
export class FooterModule { }